import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { restaurantConfig } from "@/config/restaurantConfig";

// Mock kitchen/KDS signal. NOT live data — structured for future backend.
export function KitchenStatus() {
  const { t } = useLang();
  if (!restaurantConfig.kitchenLoad) return null; // no kitchen signal for this tenant
  const calm = restaurantConfig.kitchenLoad !== "busy";
  const [lo, hi] = restaurantConfig.prepRangeMin || [15, 20];
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-4 flex items-center justify-between gap-3 rounded-2xl border border-border bg-card p-3.5 shadow-soft"
      data-testid="kitchen-status"
    >
      <span className="flex items-center gap-2 text-sm font-semibold">
        <span className={`relative flex h-2.5 w-2.5`}>
          <span className={`absolute inline-flex h-full w-full rounded-full ${calm ? "bg-success" : "bg-amber-500"} opacity-60 ${calm ? "" : "animate-ping"}`} />
          <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${calm ? "bg-success" : "bg-amber-500"}`} />
        </span>
        {calm ? t("kitchenCalm") : t("kitchenBusy")}
      </span>
      <span className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
        <Clock className="h-3.5 w-3.5" />
        {t("estPrepRange")} {lo}–{hi} {t("min")}
        <span className="ms-1 rounded-full bg-secondary px-1.5 py-0.5 text-[9px] uppercase tracking-wide">{t("demoLabel")}</span>
      </span>
    </motion.div>
  );
}
